module.exports = __webpack_public_path__ + "img/classic_gold.63d87dba.png";